module.exports = __webpack_public_path__ + "img/avatar2.830bd79c.png";